import React, { useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { BackButton } from "../../components/common/MainButtonComponent";
import { routes } from "../../helper/routes";
import AssessmentSetupForm from "./AssessmentSetupForm";
import "./AssessShared.css";

export default function AssessmentDetailPage({
  mode = "view",
  assessment: assessmentProp = null,
  metaData: metaDataProp = null,
  metaDataOptions: metaDataOptionsProp = null,
  onClose,
}) {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const assessment = assessmentProp || location.state?.assessment || null;
  const metaData = metaDataProp || location.state?.metaData || null;
  const metaDataOptions = metaDataOptionsProp || location.state?.metaDataOptions || null;
  const returnTo = location.state?.returnTo || routes.asses_lib;
  const assessmentLibraryState = location.state?.assessmentLibraryState || null;
  const isEdit = mode === "edit";

  const handleBack = () => {
    if (typeof onClose === "function") {
      onClose();
      return;
    }

    // history.push(routes.asses_lib, {
    //   assessmentLibraryState,
    // });

    history.push(returnTo, assessmentLibraryState ? { assessmentLibraryState } : undefined);
  };


  const convertMinutesToSelectedUnit = (minutes, unitId, unitOptions = []) => {
    if (minutes === null || minutes === undefined || minutes === "") return "";

    const unit = unitOptions
      .find((option) => String(option.value) === String(unitId))
      ?.label
      ?.toLowerCase();

    const value = Number(minutes);
    if (Number.isNaN(value)) return "";

    switch (unit) {
      case "hours":
      case "hour":
        return value / 60;

      case "days":
      case "day":
        return value / 1440;

      case "weeks":
      case "week":
        return value / 10080;

      case "months":
      case "month":
        return value / 43200;

      case "minutes":
      case "minute":
        return value;

      default:
        return value;
    }
  };

  const initialValues = useMemo(() => {
    if (!assessment) {
      return {
        assessment_id: id,
      };
    }

    return {
      assessment_id: assessment.assessment_id ?? assessment.id ?? id,
      title: assessment.title ?? assessment.name ?? "",
      assessment_state: assessment.assessment_state ?? assessment.status ?? "Initial",
      status_id: assessment.status_id ?? 1,
      grade_id: assessment.grade_id ?? assessment.grade ?? null,
      subject_id: assessment.subject_id ?? assessment.subject ?? null,
      language_id: assessment.language_id ?? assessment.language ?? null,
      exam_category_id: assessment.exam_category_id ?? assessment.examCategory ?? null,
      term_id: assessment.term_id ?? assessment.term ?? null,
      author_id: assessment.author_id ?? assessment.author ?? null,
      source_id: assessment.source_id ?? assessment.source ?? null,
      grading_method_id: assessment.grading_method_id ?? 1,
      chapter_id: assessment.chapter_id ?? assessment.chapter ?? null,
      year_id: assessment.year_id ?? assessment.year ?? null,
      difficulty_id: assessment.difficulty_id ?? assessment.difficulty ?? null,
      attempt_no_id: assessment.attempt_no_id ?? 1,
      additional_info: assessment.additional_info ?? "",
      terms_content: assessment.terms_content ?? "",
      start_time: assessment.start_time ?? "",
      // exam_time_interval: assessment.exam_time_interval ?? "",
      // buffer_time: assessment.buffer_time ?? "",
      exam_time_interval: convertMinutesToSelectedUnit(
        assessment.exam_time_interval,
        assessment.exam_time_interval_unit_id,
        metaDataOptions?.durationUnitOptions || []
      ),

      buffer_time: convertMinutesToSelectedUnit(
        assessment.buffer_time,
        assessment.buffer_time_unit_id,
        metaDataOptions?.durationUnitOptions || []
      ),

      pause_duration: convertMinutesToSelectedUnit(
        assessment.pause_until,
        assessment.pause_duration_unit_id,
        metaDataOptions?.durationUnitOptions || []
      ),
      // exam_time_interval_unit_id: assessment.exam_time_interval_unit_id ?? "2",
      // buffer_time_unit_id: assessment.buffer_time_unit_id ?? "2",
      exam_time_interval_unit_id: assessment.exam_time_interval_unit_id ?? "",
      buffer_time_unit_id: assessment.buffer_time_unit_id ?? "",
      pause_duration_unit_id: assessment.pause_duration_unit_id ?? "",
      is_set_time_limit: Boolean(assessment.is_set_time_limit),
      is_pause: Boolean(assessment.is_pause),
      // pause_duration: assessment.pause_until ?? "",
      // pause_duration_unit_id: assessment.pause_duration_unit_id ?? "2",
      is_restart: Boolean(assessment.is_restart),
      is_multiple: Boolean(assessment.is_multiple),
      ismaster: assessment.ismaster === undefined ? true : Boolean(assessment.ismaster),
      no_of_parts: assessment.no_of_parts ?? 1,
      part_notation_id: assessment.part_notation_id ?? null,
      parent_assessment_id: assessment.parent_assessment_id ?? null,
      parent_assessment_title: assessment.parent_assessment_title ?? assessment.parentAssessmentTitle ?? null,
    };
  }, [assessment, id]);

  return (
    <ContentWrapper>
      <section className="assess-section">
        <div className="assess-section__header">
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <BackButton
              title="Back"
              //onClick={() => history.push(routes.asses_lib)}
              onClick={handleBack}
            />
            <div>
              <p className="assess-section__eyebrow">Assessment Library</p>
              <h1 className="assess-section__title">
                {isEdit ? "Edit Assessment" : "View Assessment"}
              </h1>
            </div>
          </div>
        </div>

        {!assessment && (
          <p className="assess-setup__meta-error">
            Assessment details are not loaded. Open this page from the library list to prefill values.
          </p>
        )}

        <AssessmentSetupForm
          mode={isEdit ? "edit" : "view"}
          submitLabel="Save Changes"
          values={initialValues}
          metaData={metaData}
          metadataOptionsOverride={metaDataOptions}
          //onClose={() => history.push(routes.asses_lib)}
          onClose={handleBack}
        />
      </section>
    </ContentWrapper>
  );
}
